const $ = require('jquery');
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import run from '../../utilities/run';
import CollateralDetailsTab from './CollateralDetailsTab.js';
import CollateralReviewTab from './CollateralReviewTab.js';
import CollateralRulesTab  from  './CollateralRulesTab.js';
import {handleQueryParamTraversalToWizardTab} from '../../utilities/jumpToWizardLogic';

// Live form from jsp
run("#new-collateral-wizard", ()=>{
	const el = $("#new-collateral-wizard");
	attachWizard(el);
	setupEditChecker();
});

function setupEditChecker(){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#new-collateral-wizard");
  EditChecker.bindCancelButton(".collateral-cancel-btn");
}

function attachWizard(el) {
	const namespace = el.data('namespace');
	const validSkuUrl = el.data('validate-sku-url');
	const collateralNameStr = [`${namespace}collateralName`];

	const validator = el.validate({
		// onkeyup: false,
  //   onfocusout: false,
		errorPlacement: function(error, element) {
			let appendClosest = $(element).data('error-placement-append-closest');
			if (appendClosest) {
				$(element).closest(appendClosest).append(error);
			} else {
				error.insertAfter(element);
			}
		},
		// rules: {
		// 	[collateralNameStr]: {
		// 		remote: {
		// 			url: validSkuUrl,
		// 			type: "post",
		// 			data: {
		// 				[collateralNameStr]: function() {
		// 					return $(`#${collateralNameStr}`).val();
		// 				}
		// 			}
		// 		}
		// 	}
		// },
		// messages:{
		// 	[collateralNameStr]: {
		// 		remote: '<liferay-ui:message key="product-duplicate-sku-error-message"/>'
		// 	}
		// }
	});

  	validator.settings.ignore = ":disabled,:hidden";

  	// create a cache to prevent round-trips to server
  	const quickWizard = new QuickWizard(el, {
	    tabletWidthNavStep: 844,
	    mobileWidthNavStep: 502,
			customRules: {
        [`#${collateralNameStr}`]: {
          errorMessageSelector: "#collateral-duplicate-sku-error-message",
          isValid: ({input, done})=>{
            const curVal = input.val();
            // check cache to see if it's busted
            if(curVal !== skuValAtLastValidation){
            	$.post(validSkuUrl,
                {[collateralNameStr]: curVal},
            		(data)=>{
                  // set cache to last-validated-value
                  skuValAtLastValidation = curVal;
            			if(data === "true"){
            				console.log("server validation returned: 'true'");
                    prevSkuErrorRes = true;
            				done(true, {displayErrors: true});
            			}
            			else{
                    prevSkuErrorRes = false;
            				console.log("server validation returned: not true");
            				done(false, {displayErrors: true});
            			}
            		}
            	)
              return done;
            }
            console.log("sku cache is same");
            return prevSkuErrorRes;
          }
        }
      },



	    shouldNavigateToForm: ({targetForm, direction, currentForm, done})=>{
	      let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);

        quickWizard.areInputsValid(allPrevInputs, {
          displayErrors: true,
          validationsComplete: (isValid)=>{
            if(!isValid){
              quickWizard.goToFirstIncompleteForm();
            }
            // manually call done when
            // ajax is done
            done(isValid);
          }
        });

	      return done;
	    },
	    didNavigateToForm: ({currentForm})=>{
	      //rulesConfigPanel.hide();
	      if(currentForm.filter(".collateral-rules-tab").length) {
	        collateralRulesTab.didNavigateToForm();
	      } else if(currentForm.filter('.collateral-review-tab').length) {
	      	collateralReviewTab.didNavigateToForm();
	      }
	    }
  	});


  	quickWizard.init();

  /*Removed for EditChecker above
	$(document).on("click", ".collateral-cancel-btn", function(e){
		$("#collateral-cancel-modal").modal("show");
    });
    */

  	const collateralDetailsTab = new CollateralDetailsTab(quickWizard);
  	collateralDetailsTab.init();

	const collateralReviewTab = new CollateralReviewTab(quickWizard);
	collateralReviewTab.init();

	const collateralRulesTab = new CollateralRulesTab(quickWizard);
	collateralRulesTab.init();

  let skuValAtLastValidation = $(`#${collateralNameStr}`).val();
  let prevSkuErrorRes = true;

  handleQueryParamTraversalToWizardTab(quickWizard);

}



// WEBPACK FOOTER //
// ./src/pages/products/productCollateral.js